<template>
  <div>
    <slot v-if="visible"></slot>
  </div>
</template>

<script>
export default {
  name: "FacetItem",
  data() {
    return {
      visible: true,
    };
  },
};
</script>
